module.exports = __webpack_public_path__ + "static/media/temp_36.dbd56e02.jpg";